export const releaseInfo = {
    version: '498724db',
}
